var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"position-relative clip d-flex"},[_c('img',{style:(_vm.rect),attrs:{"src":_vm.img}}),_c('img',{staticClass:"opacity",attrs:{"src":_vm.img}})])}
var staticRenderFns = []

export { render, staticRenderFns }